export default __webpack_public_path__ + "static/media/features-section-2.86e89bdd.png";